import { v4 as uuidv4 } from 'uuid';
import { isEmpty, uniq } from 'lodash';
import { propsReadApi } from '../../../api/curator';
import { fetchAllPages } from '../../../helpers/apiHelper';
import { dispatcher } from '../../../helpers/projectHelper';
import {
  getTextureLinking,
  loadSceneLabels,
} from '../../../redux/slicers/configurator/configurator.actions';
import {
  configuratorSceneProductsActions,
  selectSceneProducts,
  selectSceneProductsLoaded,
} from '../../../redux/slicers/configurator/configuratorSceneProducts.slicer';
import { getAppState } from '../../../redux/store';
import { configuratorModule, LabelsController } from './unityMethods';
import { loadUnityProps } from '../../../pages/admin/curator/projectParser/loadUnityProps';
import {
  configuratorActions,
  selectAllSceneInitPropsLoaded,
  selectBaseMaterialData,
  selectCalledOnce,
  selectConfiguratorData,
  selectIs360Configurator,
  selectSceneById,
  selectUnityLoaded,
} from '../../../redux/slicers/configurator/configurator.slicer';
import { configuratorUnityObjectActions } from '../../../redux/slicers/configurator/configuratorUnityObject.slicer';
import { waitForEventOnce } from '../../../helpers/unityPubSub';
import {
  // CONFIGURATOR_APP_EVENT,
  CONFIGURATOR_UNITY_EVENT,
} from './unityCallbacks';
import { errorToastV2 } from '../../../helpers/toastHelper';
import { getJson } from '../../../helpers/axiosHelper';
import { selectSceneLabels } from '../../../redux/slicers/configurator/configuratorSceneLabels.slicer';
import { getLabelOptions, getSceneViewsApi } from '../../../api/configuratorApi';
// import { loadUnityMaterialDetails } from '../../../pages/admin/curator/projectParser/loadUnityMaterialDetails';
import {
  apiGetMaterialsV2,
  apiGetRenderBasedOnProjectRenderId,
  apiGetTextureList,
} from '../../../helpers/api';
import { setUnityObjectImagesProcessing } from '../../../redux/slicers/admin/curatorLoaderSlicer';
import { undoRedo } from '../../admin/curator/UndoRedo/UndoRedo';
import { DEFAULT_FOV } from '../../../constants/productConfiguratorConstants';
import { isV2 } from '../utils';
import { updateDbTexture } from '../../../helpers/idb';

export const defaultCamera = {
  distanceToSet: 5.8743,
  fov: DEFAULT_FOV,
  xTransRot: 90,
  yTransRot: 180,
  zTransRot: 0,
  wTransRot: 0,
  centerObjectxPos: -2.0455,
  centerObjectyPos: 1.0611,
  centerObjectzPos: -0.6033,
  isCameraCorrection: false,
  lensShiftY: 0,
  cameraHeight: 0,
  cameraRotX: 0,
  cameraRotZ: 0,
  focalLength: 34,
  isdepthOfField: false,
  selectedObjectName: '',
  blurIntensity: 0,
  xPos: 3.5147,
  yPos: 1.0611,
  zPos: 5.271,
  cameraName: 'BR54 Camera_1',
  resoX: 1920,
  resoY: 1080,
  sensor_width: 20,
  sensor_height: 11.2,
};

export const retailAutomationDefaultCamera = {
  distanceToSet: 4.115504,
  fov: 20.0,
  xTransRot: 0.0,
  yTransRot: 180.0,
  zTransRot: 0.0,
  centerObjectxPos: 0.01873487,
  centerObjectyPos: 0.980176747,
  centerObjectzPos: -0.00574419834,
  isCameraCorrection: false,
  lensShiftY: 0.0,
  cameraHeight: 0.980176747,
  cameraRotX: 180.0,
  cameraRotZ: 0.0,
  focalLength: 31.7591782,
  isdepthOfField: false,
  selectedObjectName: null,
  focusXPos: '',
  focusYPos: '',
  focusZPos: '',
  blurIntensity: 5.0,
  xPos: 0.01873522,
  yPos: 0.980176747,
  zPos: 3.99425578,
  cameraName: null,
  resoX: 0.0,
  resoY: 0.0,
  isPredefinedCamera: false,
  is_lock: true,
  safeFrameWidth: 0.0,
  safeFrameHeight: 0.0,
  canvas_width: 0.0,
  canvas_height: 0.0,
  sensor_width: 20.0,
  sensor_height: 11.2,
  gate_fit: 'overscan',
  fov_axis: 'vertical',
  horizontalFov: 0.0,
  startAngle: 0,
  lastAngle: 360,
};

export const resetData = () => {
  dispatcher(configuratorActions.setAllDataProcessed(true));
  dispatcher(configuratorActions.setUnitySceneLoaded(true));
  dispatcher(configuratorActions.setAllOptionsLoaded(true));
};

export const initializeConfigurator = () => {
  const configuratorData = selectConfiguratorData(getAppState());
  const is360Configurator = selectIs360Configurator(getAppState());
  const isNewConfigurator = Boolean(configuratorData?.is_new_configurator);
  const config = {
    roomCameraInfo: defaultCamera,
    transformData: {},
    props: [],
    userCameraInfo: [],
    materialVersion: 'V3',
    // baseMaterialData: {},
    // selectedOption: {},
    isNewConfigurator,
  };
  if (!isV2()) {
    config.isThreeSixtyConfigurator = is360Configurator;
  }
  configuratorModule.InitializeConfigurator(config);
  configuratorModule.projectModule.SendRoomLoadedCompletelyInfo();
  // dispatcher(configuratorActions.setSelectedOptionAll({}));
  dispatcher(configuratorActions.setAllDataProcessed(true));
};

export const initUnity = async ({ sceneId }) => {
  if (!sceneId) {
    resetData();
    return;
  }
  // TODO: refactor this logic -> or wait when unity implements it
  const callOnlyOnce = selectCalledOnce(getAppState());
  const is360Configurator = selectIs360Configurator(getAppState());
  const configuratorData = selectConfiguratorData(getAppState());
  const isNewConfigurator = Boolean(configuratorData?.is_new_configurator);
  const baseMaterialData = selectBaseMaterialData(getAppState());
  dispatcher(configuratorUnityObjectActions.setPropTree([]));
  dispatcher(configuratorActions.setAllSceneInitPropsLoaded(false));
  dispatcher(configuratorActions.setUnitySceneLoaded(false));
  // need to check if there is an issue if we don't reset the initial properties of the object
  // dispatcher(configuratorActions.updateInitialObjectProperties([]));
  dispatcher(configuratorActions.setMaterialToUpdate([]));
  setUnityObjectImagesProcessing(false);
  dispatcher(configuratorActions.setInitialMaterialApplied(false));
  dispatcher(configuratorActions.setDefaultTextures(null));
  dispatcher(configuratorActions.setAllDataProcessed(false));
  dispatcher(configuratorActions.setAddRenderersCount(0));
  dispatcher(configuratorActions.setBackupDefaultTextures([]));
  dispatcher(configuratorActions.resetUnlinkedObjectsAfterDelete([]));
  dispatcher(
    configuratorActions.setObjectsAfterDeleteOperationCompleted({
      rawData: [],
      parentData: [],
    })
  );
  dispatcher(configuratorUnityObjectActions.setSelectedObjects([]));
  dispatcher(configuratorActions.setAllOptionsLoaded(false));
  undoRedo.resetHistory();

  if (callOnlyOnce) {
    configuratorModule.ResetConfiguratorReceiver();
    await waitForEventOnce(CONFIGURATOR_UNITY_EVENT.OnConfiguratorSceneLoaded);
    // PubSub.publish(CONFIGURATOR_APP_EVENT.RESET_CONFIGURATOR_SCENE);
  }

  initSceneLables(sceneId);

  const sceneJson = await getSceneJson(sceneId);

  if (sceneJson === false) {
    errorToastV2('Unable to load scene json. LF_C_992S');
    resetData();
    return;
  }

  const unityProps = await getInitialUnityProps(sceneJson);
  if (isEmpty(unityProps)) {
    dispatcher(
      configuratorSceneProductsActions.fetchSceneProductsSuccess({ sceneId, products: [] })
    );
  }

  if (!baseMaterialData) {
    const materials = await apiGetMaterialsV2({ query: 'search=Matte+Finish', page: 1 });
    if (materials?.results?.length) {
      dispatcher(configuratorActions.setBaseMaterialData(materials?.results[0]));
    }
  }

  if (!sceneJson) {
    initializeConfigurator();
    return;
  }

  const config = {
    roomCameraInfo: sceneJson.roomCameraInfo,
    roomLightData: sceneJson?.roomLightData || [],
    transformData: sceneJson.transformChangedObjectData || {},
    deletedObjectsData: sceneJson?.deletedObjectsData || sceneJson?.deletedObjectData || [],
    propsHierarchyData: sceneJson.propsHierarchyData,
    materialDetails: sceneJson.materialDetails,
    materialVersion: sceneJson.materialVersion,
    duplicatePropDatas: sceneJson.duplicatePropDatas,
    // selectedOption: sceneJson?.selectedOption || {},
    // baseMaterialData: sceneJson?.baseMaterialData || {},
    userCameraInfo: [],
    labelOptionsDict: null,
    props: unityProps,
    isNewConfigurator,
  };

  if (!isV2()) {
    config.isThreeSixtyConfigurator = is360Configurator;
  }

  configuratorModule.CreateConfiguratorReceiver(config);

  // dispatcher(configuratorActions.setSelectedOptionAll(sceneJson?.selectedOption || {}));

  await Promise.all([
    loadUnityProps({
      unityPropList: unityProps,
      initProp: configuratorModule.InstantiatePropReceiever,
      unityLoadedSelector: selectUnityLoaded,
      fetchProps: createPropsLoader(sceneId),
    }),
    // loadUnityMaterialDetails({
    //   materialDetails: sceneJson.materialDetails,
    //   unityContext: configuratorModule,
    //   unityLoadedSelector: selectUnityLoaded,
    // }),
  ]);
};

const getInitialUnityProps = async (sceneJson) => {
  const unityPropList = sceneJson?.blenderAssetBundleDatas?.map((a) => {
    const transformProp = sceneJson?.transformChangedObjectData?.[a?.objectName];
    if (transformProp) {
      return {
        type: 'ConfiguratorProjectProp',
        id: a.id,
        objectName: a.objectName,
        indexName: a.objectIndex,
        xPosition: transformProp.xPosition,
        yPosition: transformProp.yPosition,
        zPosition: transformProp.zPosition,
        xRotation: transformProp.xRotation,
        yRotation: transformProp.yRotation,
        zRotation: transformProp.zRotation,
        wRotation: transformProp.wRotation,
        xScale: transformProp.xScale,
        yScale: transformProp.yScale,
        zScale: transformProp.zScale,
        propLoaderId: uuidv4(),
      };
    }
    return null;
  });
  const propListWithData = unityPropList?.filter((val) => Boolean(val));
  return propListWithData;
};

const createPropsLoader = (sceneId) => async (propIds) => {
  if (isEmpty(propIds)) {
    dispatcher(
      configuratorSceneProductsActions.fetchSceneProductsSuccess({ sceneId, products: [] })
    );
    return {
      results: [],
    };
  }

  const sceneProducs = selectSceneProducts(sceneId)(getAppState());
  const sceneProducsLoaded = selectSceneProductsLoaded(sceneId)(getAppState());

  if (sceneProducsLoaded) {
    return {
      results: sceneProducs,
    };
  }

  const propIdList = propIds;

  dispatcher(configuratorSceneProductsActions.fetchSceneProductsStart({ sceneId }));

  let props = [];

  const uniqPropIdList = uniq(propIdList);

  const propsObj = {};

  await Promise.all(
    uniqPropIdList.map(async (productId) => {
      const result = await fetchAllPages((page) => propsReadApi([productId], page));
      // TODO: handle prop loading failed
      propsObj[productId] = result?.results || [];
      // props = props.concat(result?.results || []);
    })
  );

  propIdList.map((val) => {
    if (propsObj?.[val]) {
      props = props.concat(propsObj?.[val]);
    }
  });

  if (!props?.length) {
    errorToastV2('Product is not present');
  }

  dispatcher(
    configuratorSceneProductsActions.fetchSceneProductsSuccess({ sceneId, products: props })
  );

  return {
    results: props,
  };
};

export const getSceneJson = async (sceneId, isUpdate = true) => {
  const scene = selectSceneById(sceneId)(getAppState());
  let sceneJson = scene?.json_file_content;

  if (!sceneJson) {
    // it's not loaded yet or it's missing

    if (scene?.json_file) {
      try {
        sceneJson = await getJson(scene.json_file);
        if (isUpdate) {
          dispatcher(
            configuratorActions.updateScene({ id: scene.id, json_file_content: sceneJson })
          );
        }
      } catch (e) {
        errorToastV2('Unable to load scene configuration. CODE: LF_C_78324');
        return false;
      }
    }
  }

  // current scene doesn't have json file yet, return nothing

  return sceneJson;
};

export const initSceneLables = async (sceneId) => {
  const loadDataPromises = [];
  const initPropsLoaded = selectAllSceneInitPropsLoaded(getAppState());

  loadDataPromises.push(loadSceneLabels({ sceneId, onlyOnce: false }));

  if (!initPropsLoaded) {
    loadDataPromises.push(waitForEventOnce(CONFIGURATOR_UNITY_EVENT.OnAllConfiguratorPropsLoaded));
  }

  // const cancelPromise = waitForEventOnce(CONFIGURATOR_APP_EVENT.RESET_CONFIGURATOR_SCENE)

  const result = await Promise.race([
    Promise.all(loadDataPromises),
    // cancelPromise
  ]);

  if (!Array.isArray(result)) {
    // scene was reset we don't need to load labels
    return;
  }

  // all scene props was just loaded and we fetched labels data
  // now we can add labels to unity

  const labels = selectSceneLabels(sceneId)(getAppState());
  let allObjects = [];

  dispatcher(getSceneViewsApi({ sceneId, showLoading: false, onlyOnce: false }));
  
  if (isV2()) {
    getTextureLinking({ sceneId });
  }

  labels.forEach((label) => {
    if (!label.data?.linkedObjects) return;
    const objectNames = label.data.linkedObjects.map((o) => o.objectName);
    allObjects = allObjects.concat(objectNames);
    if (objectNames?.length) {
      LabelsController.AddRenderersToGroup(label.id, objectNames);
    }
  });

  await Promise.all(
    labels.map(async (label) => {
      await dispatcher(getLabelOptions({ labelId: label.id, onlyOnce: false }));
    })
  );

  dispatcher(configuratorActions.setAllOptionsLoaded(true));

  if (!allObjects?.length) {
    configuratorModule.projectModule.SendRoomLoadedCompletelyInfo();
    dispatcher(configuratorActions.setAllDataProcessed(true));
  }
};

export const removeLoader = () => {
  dispatcher(configuratorActions.setShowFullScreenLoader(false));
};

export const getProjectJsonData = async (toOperate, loadedFrom) => {
  let projectJson;
  let renderId;
  if (loadedFrom === 'projects' || loadedFrom === 'rooms') {
    const jsonFile = toOperate.json_file;
    if (!jsonFile) {
      removeLoader();
      errorToastV2('Project configuration is missing. CODE: LF_93lskd27');
      return;
    }
    try {
      projectJson = await getJson(jsonFile);
    } catch (e) {
      removeLoader();
      errorToastV2('Project configuration is missing. CODE: LF_78324');
      return;
    }
  }
  if (loadedFrom === 'images') {
    // load render
    const getRenderResult = await apiGetRenderBasedOnProjectRenderId(toOperate.object_id);
    renderId = toOperate.id;
    if (!getRenderResult?.data?.result?.id) {
      removeLoader();
      errorToastV2('Project configuration is missing. CODE: LF_78324');
      return;
    }

    const renderData = getRenderResult.data.result;

    // if (renderData.render_name) {
    //   dispatch(setPageTitle(`Render: "${renderData.render_name}"`));
    // }

    if (!renderData.json_data) {
      // errorToastV2('Unable to load room, render json data is missing, LF_783koo24')
      return;
    }

    projectJson = renderData.json_data;

    const automationActionData = renderData.automation_action || {};

    if (Object.keys(automationActionData).length > 0) {
      projectJson.automationObjectsData = await Promise.all(
        automationActionData.aa_objects.map(async (a) => {
          if (!a.color_code && !a.texture?.id) return;

          let url;
          if (a.texture) {
            const query = `id=${a.texture.id}`;
            const textures = await apiGetTextureList({ query });
            const texture = textures.results?.[0];
            const textureDbData = await updateDbTexture(texture);
            url = textureDbData?.file;
          }

          const urlHttp = a.texture?.texture_file;

          let ext;
          if (urlHttp) {
            ext = urlHttp.split(/[#?]/)[0].split('.').pop().trim();
          }

          return {
            objectName: a.object_name,
            colorCode: a.color_code,
            textureId: a.texture?.id,
            textureName: a.texture?.name,
            textureUrl: url,
            textureVersion: a.texture?.version,
            textureFormat: ext,
            skuId: a.texture?.sku_id,
            textureWidth: a.texture?.width,
            textureHeight: a.texture?.height,
          };
        })
      );

      projectJson.automationObjectsData = projectJson.automationObjectsData.filter(
        (a) => a !== undefined
      );
    }
  }
  return { projectJson, renderId };
};
